import RecipeCard from './RecipeCard';
import useRecipe from '@/hooks/server/useRecipe';
import LoadingOverlay from '@/common/LoadingOverlay';
import useStore, { selectCountryTheme } from '@/hooks/client/useStore';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const css = {
  favoriteRecipeText: (color) => ({
    fontWeight: 'bold',
    color: color,
    textAlign: 'center',
    my: 5,
  }),
};

const FavoriteRecipe = () => {
  const countryTheme = useStore(selectCountryTheme);
  const { data, isLoading, isError } = useRecipe({ id: 1 });

  if (isLoading) return <LoadingOverlay />;

  if (!data || isError) return null;

  return (
    <Box>
      <Typography variant="h1" sx={css.favoriteRecipeText(countryTheme.navColor)}>
        Receta destacada
      </Typography>
      <RecipeCard card={data} />
    </Box>
  );
};

export default FavoriteRecipe;
